import { render, staticRenderFns } from "./SubmitReport.vue?vue&type=template&id=2a99542e&"
import script from "./SubmitReport.vue?vue&type=script&lang=js&"
export * from "./SubmitReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports